<script>
  export let name, type, label, value
</script>

<div class="input-container">
  <label for={name}>
    {label}
  </label>
  <input id={name} name={name} type={type} value={value ? value : null}>
</div>

<style lang="scss">
  @import '../scss/media-sizes';
  .input-container {
    position: relative;
    &:after {
      content: '';
      display: block;
      width: 100%;
      height: 4px;
      background-image: url('/img/input-border.png');
      background-size: 100% 100%;
      background-position: left center;
      position: relative;
      top: -2px;
      background-repeat: no-repeat;
    }
  }
  label {
    font-size: 16px;
    color: #fff;
    font-family: 'myriad-pro', sans-serif;
    font-weight: 500;
    font-style: normal;
  }
  input {
    width: 100%;
    background-color: rgba(255,255,255,.1);
    border-radius: 3px;
    padding: 9px;
    font-size: 16px;
    color: #fff;
    font-family: 'myriad-pro', sans-serif;
    font-weight: 500;
    font-style: normal;
  }
  @media screen and (max-width: $mediaQueryMid) {
    label {
      font-size: 16px;
    }
    input {
      padding: 12px;
      font-size: 17px;
    }
  }
</style>